import '.a{display:flex;}.ssr-plugin'
import '.ae{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ck{background:var(--palette-white);}.ssr-plugin'
import '.y{flex-grow:1;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.b5{max-width:77.5rem;}.ssr-plugin'
import '.e2{justify-content:stretch;}.ssr-plugin'
import '.e3{position:sticky;}.ssr-plugin'
import '.e0{top:0px;}.ssr-plugin'
import '.e4{z-index:10;}.ssr-plugin'
import '.e5{padding-block:1rem;}.ssr-plugin'
import '.e6{height:3rem;}.ssr-plugin'
import '.a2{justify-content:space-between;}.ssr-plugin'
import '.bp{flex-wrap:wrap;}.ssr-plugin'
import '.e7{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b4{margin-top:2rem;}.ssr-plugin'
import '.gf{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ae b e ck"
      >
        <div className="y a f b e"
        >
          <div className="b5 a e e2 e3 e0 e4"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="e5 e6 a a2 f bp"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="e7 a e ae b4 gf b5"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
